<template>
  <section class="report-wrapper" id="pdf-content">
    <b-card no-body>
      <table class="w-100">
        <thead>
          <tr>
            <td>
              <div class="header-space">
                <b-card-body class="report_header pb-0">
                  <div class="company">
                    <h3 class="mb-1 text-left colorBlack">
                      {{ userData.company_name_cn }}
                    </h3>
                  </div>
                  <div class="title d-flex justify-content-between">
                    <h5 class="mb-0 colorBlack">收款報表</h5>
                    <label>列印時間：{{ getDateTime() }}</label>
                  </div>
                  <div class="info my-50">
                    <b-row>
                      <b-col cols="10">
                        <b-row>
                          <b-col cols="6">
                            <b-row>
                              <b-col cols="4"><b>還款日期：</b></b-col>
                              <b-col
                                cols="8"
                                v-if="date_range.from || date_range.to"
                              >
                                {{ date_range.from }} -
                                {{ date_range.to }}
                              </b-col>
                              <b-col cols="8" v-else> 不限 </b-col>
                            </b-row>
                          </b-col>

                          <b-col cols="6"></b-col>
                          <b-col cols="6">
                            <b-row>
                              <b-col cols="4"><b>借貸類型：</b></b-col>
                              <b-col cols="8" v-if="loan_type">{{
                                loan_type
                              }}</b-col>
                              <b-col cols="8" v-else> 不限 </b-col>
                            </b-row>
                          </b-col>
                          <b-col cols="6">
                            <b-row>
                              <b-col cols="4"><b>還款方式：</b></b-col>
                              <b-col cols="8" v-if="receive_method">{{
                                receive_method
                              }}</b-col>
                              <b-col cols="8" v-else> 不限 </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </div>
                </b-card-body>
              </div>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <b-card-body class="py-50 report_content">
                <table class="report-table">
                  <thead>
                    <tr>
                      <th>收據日期</th>
                      <th>供款日期</th>
                      <th>貸款編號</th>
                      <th>借款人姓名</th>
                      <th>身份證號碼</th>
                      <th>還款方式</th>
                      <th>還款類別</th>
                      <th>收款編號</th>
                      <th>還款期數</th>
                      <th>總期數</th>
                      <th>本金</th>
                      <th>利息</th>
                      <th>本+息</th>
                      <th>逾期利息</th>
                      <th>附加費</th>
                      <th>收款金額</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item of reportList" :key="item.id">
                      <th>{{ item.receipt_date }}</th>
                      <th>{{ item.payment_date.slice(0, 10) }}</th>
                      <th>{{ item.contract_number }}</th>
                      <th>{{ item.name_cn }}</th>
                      <th>{{ item.id_number }}</th>
                      <th>{{ item.receive_method }}</th>
                      <th>{{ item.payment_type }}</th>
                      <th>{{ item.receipt_number }}</th>
                      <th>{{ item.period }}</th>
                      <th>{{ item.total_period }}期</th>
                      <th>{{ formatCurrency(item.principal) }}</th>
                      <th>{{ formatCurrency(item.interest) }}</th>
                      <th>{{ formatCurrency(item.principal_and_interest) }}</th>
                      <th>{{ formatCurrency(item.defer_fee) }}</th>
                      <th>{{ formatCurrency(item.additional_fee) }}</th>
                      <th>{{ formatCurrency(item.amount) }}</th>
                    </tr>
                  </tbody>
                </table>
              </b-card-body>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>
              <div class="footer-space">&nbsp;</div>
            </td>
          </tr>
        </tfoot>
      </table>
      <b-card-body class="report_footer py-0">
        <table class="report-table">
          <tfoot>
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th>
                {{
                  formatCurrency(
                    reportList.reduce(
                      (acc, curr) => acc + Number(curr.principal),
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  formatCurrency(
                    reportList.reduce(
                      (acc, curr) => acc + Number(curr.interest),
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  formatCurrency(
                    reportList.reduce(
                      (acc, curr) => acc + Number(curr.principal_and_interest),
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  formatCurrency(
                    reportList.reduce(
                      (acc, curr) => acc + Number(curr.defer_fee),
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  formatCurrency(
                    reportList.reduce(
                      (acc, curr) => acc + Number(curr.additional_fee),
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  formatCurrency(
                    reportList.reduce(
                      (acc, curr) => acc + Number(curr.amount),
                      0
                    )
                  )
                }}
              </th>
            </tr>
          </tfoot>
        </table>
        <b
          v-if="loading"
          class="d-flex justify-content-center align-items-center"
        >
          <b-spinner small class="mr-1"></b-spinner>
          載入中...
        </b>
        <b
          v-else-if="reportList.length == 0"
          class="d-flex justify-content-center"
          >沒有過濾或沒有符合條件的數據</b
        >
      </b-card-body>
    </b-card>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BCardText,
  BSpinner,
} from "bootstrap-vue";

export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      month: [
        "Jan",
        "Feb",
        "March",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    };
  },
  methods: {},
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardText,
    BSpinner,
  },
  props: {
    reportList: {
      type: Array,
      required: true,
    },
    loan_type: {},
    receive_method: {},
    date_range: {},
    loanTypeOptions: {
      type: Array,
      required: true,
    },
    receiveMethodOptions: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },

  mounted() {
    // this.$nextTick(() => {
    //     setTimeout(() => {
    //         this.$emit("domRendered");
    //     }, 1000);
    // });
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "~@core/scss/base/components/variables-dark";
.report-table {
  font-size: 12px;
  th {
    width: 50px;
    font-size: 11px;
  }
}
</style>
